import Axios from 'axios';

window.axios = Axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
function getCSRFToken() {
    let csrftoken = getCookie('csrftoken');
    if (!csrftoken) {
        csrftoken = $('input[name=csrfmiddlewaretoken]').val();
    }
    return csrftoken;
}

function getCookie(name) {
    const regex = new RegExp(`(?:(?:^|;\\s*)${name}=([^;]*))`);
    const match = document.cookie.match(regex);
    return match ? decodeURIComponent(match[1]) : null;
}

const token = getCSRFToken();

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
    window.axios.defaults.headers.common['X-CSRFToken'] = token;
}
